import store from '../store/index'

const UNWATCH_KEY = '__loadButtonUnwatch__'
const BINDING_KEY = '__loadButtonBindingValue__'

function cleanup (el) {
  if (!el) {
    return
  }

  el[UNWATCH_KEY]?.()
  delete el[UNWATCH_KEY]
  delete el[BINDING_KEY]

  el.disabled = ''

  const loadingChild = getLoadingChild(el)
  if (loadingChild) {
    loadingChild.remove()
  }
}

function bindStoreWatcher (el, binding) {
  if (!binding?.value || el.disabled) {
    return
  }

  el[BINDING_KEY] = binding.value
  el[UNWATCH_KEY] = store.watch(() => store.getters[binding.value], (value) => {
    if (value === true) {
      el.disabled = 'true'
      if (getLoadingChild(el)) {
        return
      }
      el.innerHTML = el.innerHTML + '<span class="cssloader-remove" style="display:inline-block; vertical-align: middle; margin-left: 5px;"><div class="cssload-container"><div class="cssload-speeding-wheel"></div></div></span>'
    } else {
      el.disabled = ''
      if (getLoadingChild(el)) {
        getLoadingChild(el).remove()
      }
    }
  })
}

export default {
  mounted (el, binding) {
    bindStoreWatcher(el, binding)
  },
  updated (el, binding) {
    if (el[BINDING_KEY] === binding?.value) {
      return
    }

    cleanup(el)
    bindStoreWatcher(el, binding)
  },
  unmounted (el) {
    cleanup(el)
  }
}

function getLoadingChild (doc) {
  let notes = null
  for (let i = 0; i < doc.childNodes.length; i++) {
    if (doc.childNodes[i].className === 'cssloader-remove') {
      notes = doc.childNodes[i]
      break
    }
  }
  return notes
}
